export default function initResourcePagination() {


    const { hasPageNumQuery, pageNumQuery } = gatherURLParams();
    const {
            paginationContainer,
            pageCount,

            leftLabel,
            leftChevron,
            leftControls,

            rightLabel,
            rightChevron,
            rightControls,

            activePaginationElement,
            activePaginationElementLink
    } = gatherDOMElements(hasPageNumQuery, pageNumQuery);
    const activeInt = pageNumQuery !== null ? parseInt(pageNumQuery) : null;

    //If we have zero or 1 pages, none of this logic runs
    if (pageCount === 0 || pageCount === 1) {
        return;
    }
    //We have pages
    else {

        //highlight class on the first pagination link
        activePaginationElement.classList.add('resource-pagination__list-item--active');
        activePaginationElementLink.classList.add('resource-pagination__link--active');

        //Are we on the first page?
        if (!hasPageNumQuery || activeInt === 1) {

            //Disable left controls
            disableControls(leftControls);

        }
        //Are we on the last page?
        if (pageNumQuery !== null && activeInt === pageCount) {

            //Disable right controls
            disableControls(rightControls)
        }

        //Finally we set the chevron link destinations.
        //If we're on the first page, just set last one
        //if we're on the last page, just set first one
        //otherwise set both
        if (!hasPageNumQuery || pageNumQuery === "1") {
            rightChevron.closest('a').setAttribute('href', `${window.location.origin}/resources?pageNum=2`)
        }
        else if (pageCount === parseInt(pageNumQuery)) {
            leftChevron.closest('a').setAttribute('href', `${window.location.origin}/resources?pageNum=${activeInt - 1}`);
        }
        else {
            rightChevron.closest('a').setAttribute('href', `${window.location.origin}/resources?pageNum=${activeInt + 1}`);
            leftChevron.closest('a').setAttribute('href', `${window.location.origin}/resources?pageNum=${activeInt - 1}`);
        }
        

    }
}

function disableControls(controls) {
    for (const control of controls) {
        if (control.tagName === "A") {
            control.classList.add('resource-pagination__link--link-disabled')
        }
        else if (control.tagName === "I") {
            control.classList.add('resource-pagination__link--chevron-disabled');
        }
    }
}

function enableControls(controls) {
    for (const control of controls) {
        if (control.tagName === "A") {
            control.classList.remove('resource-pagination__link--link-disabled')
        }
        else if (control.tagName === "I") {
            control.classList.remove('resource-pagination__link--chevron-disabled')
        }
    }
}

function gatherDOMElements(hasPageNumQuery, pageNumQuery) {
    const paginationContainer = document.querySelector('.resource-pagination');
    const pageCount = parseInt(paginationContainer.dataset.pagination);
    const leftLabel = document.querySelector('.resource-pagination__first-link');
    const leftChevron = document.querySelector('.resource-pagination__chevron-left');
    const rightLabel = document.querySelector('.resource-pagination__last-link');
    const rightChevron = document.querySelector('.resource-pagination__chevron-right');
    const activePaginationElement = hasPageNumQuery ? document.querySelector(`#page-link-${pageNumQuery}`) : document.querySelector('#page-link-1');
    const activePaginationElementLink = activePaginationElement ? activePaginationElement.querySelector('a') : null;

    return {
        paginationContainer: paginationContainer,
        pageCount: pageCount,

        leftLabel: leftLabel,
        leftChevron: leftChevron,
        leftControls: [leftLabel, leftChevron],

        rightLabel: rightLabel,
        rightChevron: rightChevron,
        rightControls: [rightLabel, rightChevron],

        activePaginationElement: activePaginationElement,
        activePaginationElementLink: activePaginationElementLink
    }
}

function gatherURLParams() {

    const urlParams = new URLSearchParams(window.location.search);
    const hasPageNumQuery = urlParams.has('pageNum');
    const pageNumQuery = urlParams.get('pageNum');

    return {
        hasPageNumQuery: hasPageNumQuery,
        pageNumQuery: pageNumQuery,
    }
}